import { toast } from "../../components/Toast";
import axios from "axios";
import {
  FETCH_INITIAL_PARAMS_SUCCESSFUL,
  SET_SELECTED_CITY,
  SET_LOADER_ON,
  SET_LOADER_OFF,
  SET_DELIVERY_LOCATION,
  SET_MODAL_ON,
  SET_MODAL_OFF,
  SET_PAYMENT_METHODS,
  SET_VOUCHERY_END_POINT,
  SET_SITEWIDE_PROMO_DETAILS,
  FETCH_CURRENT_DISTRICT_CODE,
  SET_APPLICATION_TYPE,
  SET_OPERATING_HOURS,
  FETCH_RESTAURANT_SUCCESS,
  FETCH_MENU_SUCCESS,
  VIRTUAL_WAITER_CONFIGURATIONS,
  SELECTED_LOCATION_INFO,
  SELECTED_LOCATION_COORDINATES,
  SET_LANGUAGE_LIST,
  SET_RAW_MENU_DATA,
  SET_LANGUAGE,
} from "../actionTypes";
import {
  FETCH_APP_CONFIGURATION,
  FETCH_NEAREST_LOCATION,
  FETCH_APP_MENU,
  FETCH_PROMOTIONS,
} from "../../utils/apiConstants";
import TagManager from "react-gtm-module";
import Hashmap from "hashmap";
import {
  DELIVERY_LOCATION_PICKER,
  SEARCH,
  ROOT,
} from "../../utils/routeConstants";

const locationApiEndPoint = process.env.REACT_APP_LOCATION_API_URL;
const appApiEndPoint = process.env.REACT_APP_WEB_ORDER_API_URL;

// online-order/virtual waiter
export const setApplicationType = (type, params) => {
  return (dispatch) => {
    if (type === "MENU_TEST") {
      dispatch({ type: SET_APPLICATION_TYPE, payload: "MENU_TEST" });
      dispatch({ type: VIRTUAL_WAITER_CONFIGURATIONS, payload: params });
    } else {
      dispatch({
        type: FETCH_INITIAL_PARAMS_SUCCESSFUL,
        payload: {},
      });

      dispatch({
        type: FETCH_RESTAURANT_SUCCESS,
        payload: {},
      });

      dispatch({
        type: SET_OPERATING_HOURS,
        payload: [],
      });

      dispatch({
        type: FETCH_MENU_SUCCESS,
        payload: {},
      });
    }
  };
};

export const updateDistrictCode = (districCode) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_CURRENT_DISTRICT_CODE, payload: districCode });
  };
};

const getTranslationKeys = (obj, languageCodeSet) => {
  const nameTranslations = Object.keys(obj?.name?.translations ?? {});
  const descTranslations = Object.keys(obj?.description?.translations ?? {});

  [...nameTranslations, ...descTranslations].forEach((key) => {
    languageCodeSet.add(key);
  });
};

const getDoubleAmount = (amount, currencyCode) => {
  const fractionDigit = 2;
  return parseFloat(amount / Math.pow(10, fractionDigit));
};

const getTranslation = (data, languageCode = "en-US") => {
  if (data?.translations?.[languageCode] != null) {
    return data.translations[languageCode];
  }
  const match = Object.keys(data?.translations ?? {}).find(
    (key) => key.toLowerCase() === languageCode.toLowerCase()
  );
  return match ? data.translations[match] : data.translations["en-US"];
};

const convertMenu = (menuApiResponseOb) => {
  const apiMenuData = menuApiResponseOb;
  let rootData = [];
  // eslint-disable-next-line
  apiMenuData.categories.map(function(categoryData) {
    let menuItemDataList = [];
    // eslint-disable-next-line
    categoryData.items.map(function(itemData) {
      let menuItem = apiMenuData.items.find((data) => data.id === itemData);

      if (menuItem !== undefined) {
        let modifierGroupDataList = [];
        // eslint-disable-next-line
        menuItem.modifierGroups.map(function(modifierGroupId) {
          let modifierGroup = apiMenuData.modifierGroups.find(
            (data) => data.id === modifierGroupId
          );

          if (modifierGroup !== undefined) {
            let modifierDataList = [];
            // eslint-disable-next-line
            modifierGroup.modifiers.map(function(modifierId) {
              let modifier = apiMenuData.items.find(
                (data) => data.id === modifierId
              );

              if (modifier !== undefined) {
                if (modifier.availability !== "UNAVAILABLE") {
                  let modifierData = {
                    modifierId: modifier.id,
                    displayName: modifier.name.translations["en-US"],
                    modifierQty: modifier.quantityInfo.maxPermitted,
                    price: getDoubleAmount(
                      modifier.priceInfo.price,
                      apiMenuData.currencyCode
                    ),
                    active: true,
                  };
                  modifierDataList.push(modifierData);
                }
              }
            });

            let modifierGroupData = {
              modifierGroupId: modifierGroup.id,
              groupName: modifierGroup.name.translations["en-US"],
              min: modifierGroup.quantityInfo.minPermitted,
              max: modifierGroup.quantityInfo.maxPermitted,
              modifier: modifierDataList,
            };
            modifierGroupDataList.push(modifierGroupData);
          }
        });

        if (menuItem.availability !== "UNAVAILABLE") {
          let menuData = {
            id: menuItem.id,
            internalId: menuItem.internalId,
            name: menuItem.name.translations["en-US"],
            details: menuItem.description.translations["en-US"],
            images: [menuItem.imageUrl],
            recipeIds: [
              {
                internalId: menuItem.id,
                intId: menuItem.internalId,
                sellingPrice: getDoubleAmount(
                  menuItem.priceInfo.price,
                  apiMenuData.currencyCode
                ),
                integerPrice: menuItem.priceInfo.price,
                recipe: {
                  id: menuItem.id,
                  name: menuItem.name.translations["en-US"],
                  details: menuItem.description.translations["en-US"],
                  modifiersGroups: modifierGroupDataList,
                },
              },
            ],
          };

          menuItemDataList.push(menuData);
        }
      }
    });

    let menuData = {
      internalId: categoryData.id,
      categoryData: {
        id: categoryData.id,
        name: categoryData.name.translations["en-US"],
        isOpenCategory: checkOperationHoursValidation(
          categoryData.servingHours
        ),
        menuList: menuItemDataList,
      },
    };
    rootData.push(menuData);
  });

  return rootData;
};

const convertMenuWithLanguage = (
  menuApiResponseOb,
  languageCode = "en-us",
  dispatch
) => {
  const languageCodeSet = new Set();
  const apiMenuData = menuApiResponseOb;
  const rootData = [];

  getTranslationKeys(apiMenuData, languageCodeSet);
  // eslint-disable-next-line
  apiMenuData.categories.map(function(categoryData) {
    const menuItemDataList = [];
    // eslint-disable-next-line
    getTranslationKeys(categoryData, languageCodeSet);
    categoryData.items.map(function(itemData) {
      const menuItem = apiMenuData.items.find((data) => data.id === itemData);
      if (menuItem !== undefined) {
        getTranslationKeys(menuItem, languageCodeSet);
        const modifierGroupDataList = [];
        // eslint-disable-next-line
        menuItem.modifierGroups.map(function(modifierGroupId) {
          const modifierGroup = apiMenuData.modifierGroups.find(
            (data) => data.id === modifierGroupId
          );

          if (modifierGroup !== undefined) {
            getTranslationKeys(modifierGroup, languageCodeSet);
            const modifierDataList = [];
            // eslint-disable-next-line
            modifierGroup.modifiers.map(function(modifierId) {
              const modifier = apiMenuData.items.find(
                (data) => data.id === modifierId
              );

              if (modifier !== undefined) {
                getTranslationKeys(modifier, languageCodeSet);
                if (modifier.availability !== "UNAVAILABLE") {
                  const modifierData = {
                    modifierId: modifier.id,
                    displayName: getTranslation(modifier.name, languageCode),
                    modifierQty: modifier.quantityInfo.maxPermitted,
                    price: getDoubleAmount(
                      modifier.priceInfo.price,
                      apiMenuData.currencyCode
                    ),
                    active: true,
                  };
                  modifierDataList.push(modifierData);
                }
              }
            });

            const modifierGroupData = {
              modifierGroupId: modifierGroup.id,
              groupName: getTranslation(modifierGroup.name, languageCode),
              min: modifierGroup.quantityInfo.minPermitted,
              max: modifierGroup.quantityInfo.maxPermitted,
              modifier: modifierDataList,
            };
            modifierGroupDataList.push(modifierGroupData);
          }
        });

        if (menuItem.availability !== "UNAVAILABLE") {
          const menuData = {
            id: menuItem.id,
            internalId: menuItem.internalId,
            name: getTranslation(menuItem.name, languageCode),
            details: getTranslation(menuItem.description, languageCode),
            images: [menuItem.imageUrl],
            recipeIds: [
              {
                internalId: menuItem.id,
                intId: menuItem.internalId,
                sellingPrice: getDoubleAmount(
                  menuItem.priceInfo.price,
                  apiMenuData.currencyCode
                ),
                integerPrice: menuItem.priceInfo.price,
                recipe: {
                  id: menuItem.id,
                  name: getTranslation(menuItem.name, languageCode),
                  details: getTranslation(menuItem.description, languageCode),
                  modifiersGroups: modifierGroupDataList,
                },
              },
            ],
          };

          menuItemDataList.push(menuData);
        }
      }
    });

    const menuData = {
      internalId: categoryData.id,
      categoryData: {
        id: categoryData.id,
        name: getTranslation(categoryData.name, languageCode),
        isOpenCategory: checkOperationHoursValidation(
          categoryData.servingHours
        ),
        menuList: menuItemDataList,
      },
    };
    rootData.push(menuData);
  });

  // LANGUAGE LOGIC
  const languageList = Array.from(languageCodeSet).map((item) =>
    item.toLowerCase()
  );
  const selectedLanguage = languageList.find(
    (item) => item === languageCode.toLowerCase()
  )
    ? languageCode
    : "en-us";

  dispatch({
    type: SET_LANGUAGE,
    payload: selectedLanguage,
  });
  dispatch({
    type: SET_LANGUAGE_LIST,
    payload: languageList,
  });

  const isRTL = document.dir === "rtl";
  if (
    selectedLanguage?.startsWith("ar") ||
    selectedLanguage?.startsWith("he")
  ) {
    if (!isRTL) document.dir = "rtl";
  } else {
    document.dir = "ltr";
  }

  const url = new URL(window.location.href);
  url.searchParams.set("locale", selectedLanguage);

  window.history.replaceState(null, "", url.toString());

  return rootData;
};

const getTimeAsNumberOfMinutes = (time) => {
  const timeParts = time.split(":");
  return timeParts[0] * 60 + parseInt(timeParts[1]);
};

const checkOperationHoursValidation = (operatingHours) => {
  const date = new Date();
  const today = date.toLocaleDateString("en-US", {
    weekday: "long",
  });

  let isOpen = false;
  operatingHours.map((operatingHour) => {
    if (today.toLowerCase() === operatingHour.dayOfWeek.toLowerCase()) {
      operatingHour.timePeriods.map((timePeriod) => {
        const currentHours =
          (date.getHours() < 10 ? "0" : "") + date.getHours();
        const currentMinutes =
          (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
        const currentTime = getTimeAsNumberOfMinutes(
          `${currentHours}:${currentMinutes}`
        );
        const openingTime = getTimeAsNumberOfMinutes(
          `${timePeriod.start.hours}:${timePeriod.start.minutes}`
        );
        const closingTime = getTimeAsNumberOfMinutes(
          `${timePeriod.end.hours}:${timePeriod.end.minutes}`
        );
        if (currentTime >= openingTime && currentTime <= closingTime) {
          isOpen = true;
        }
      });
    }
  });
  return isOpen;
};

const checkMaxOperationHour = (operatingHours) => {
  const date = new Date();
  const today = date.toLocaleDateString("en-US", {
    weekday: "long",
  });

  let maxTime = 0;
  let maxOperatingHours = [];

  operatingHours.map((operatingHour) => {
    operatingHour.servingHours.map((hourData) => {
      if (today.toLowerCase() === hourData.dayOfWeek.toLowerCase()) {
        hourData.timePeriods.map((timePeriod) => {
          const currentHours =
            (date.getHours() < 10 ? "0" : "") + date.getHours();
          const currentMinutes =
            (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
          const currentTime = getTimeAsNumberOfMinutes(
            `${currentHours}:${currentMinutes}`
          );
          const openingTime = getTimeAsNumberOfMinutes(
            `${timePeriod.start.hours}:${timePeriod.start.minutes}`
          );
          const closingTime = getTimeAsNumberOfMinutes(
            `${timePeriod.end.hours}:${timePeriod.end.minutes}`
          );

          if (currentTime >= openingTime && currentTime <= closingTime) {
            if (maxTime < closingTime) {
              maxTime = closingTime;
              maxOperatingHours = operatingHour.servingHours;
            }
          }
        });
      }
    });
  });

  const convertOperatingHours = [];
  maxOperatingHours.map((maxOperatingHours) => {
    maxOperatingHours.timePeriods.map((timePeriod) => {
      convertOperatingHours.push({
        day: capitalizeFirstLetter(maxOperatingHours.dayOfWeek),
        startTime: `${formatTwoDigitsNumber(
          timePeriod.start.hours
        )}:${formatTwoDigitsNumber(timePeriod.start.minutes)}`,
        endTime: `${formatTwoDigitsNumber(
          timePeriod.end.hours
        )}:${formatTwoDigitsNumber(timePeriod.end.minutes)}`,
      });
    });
  });
  return convertOperatingHours;
};

const formatTwoDigitsNumber = (number) => {
  if (number.toString().length == 1) {
    return ("0" + number).slice(-2);
  }
  return number;
};

const capitalizeFirstLetter = (string) => {
  const word = string.toLowerCase();
  return word.charAt(0).toUpperCase() + word.slice(1);
};

const getVoucherData = (partnerId, brandId, menuCardId) => {
  return new Promise((resolve, reject) => {
    resolve(
      axios.get(appApiEndPoint + FETCH_PROMOTIONS, {
        params: {
          partnerId: partnerId,
          brandId: brandId,
          menuId: menuCardId,
        },
      })
    );
    reject(new Error());
  });
};

export const getNearestLocation = (
  locationCoordinates,
  history,
  _,
  languageCode
) => {
  return (dispatch, getState) => {
    dispatch({ type: SET_LOADER_ON });
    const { restaurant } = getState().menu;
    const { appParams, applicationType } = getState().app;

    axios
      .get(locationApiEndPoint + FETCH_NEAREST_LOCATION, {
        params: {
          brandId: appParams.restaurantId,
          latitude: locationCoordinates.lat,
          longitude: locationCoordinates.lng,
        },
      })
      .then(async (res) => {
        if (res.status === 200) {
          const locationData = res.data;
          if (locationData.locationId !== undefined) {
            const isExistLocation = restaurant.kitchenList.find(
              (data) => data.locationId === locationData.locationId
            );

            if (isExistLocation !== undefined) {
              dispatch({
                type: FETCH_RESTAURANT_SUCCESS,
                payload: {
                  ...restaurant,
                  locationId: isExistLocation.locationId,
                  menuId: isExistLocation.menuId,
                  deliveryFee: isExistLocation.deliveryFee,
                  deliveryTimeDisplayText:
                    isExistLocation.deliveryTimeDisplayText,
                  locationName: locationData.name,
                },
              });

              if (isExistLocation.menuId && isExistLocation.locationId) {
                axios
                  .get(
                    appApiEndPoint + FETCH_APP_MENU + isExistLocation.menuId,
                    {
                      params: {
                        locationId: isExistLocation.locationId,
                      },
                    }
                  )
                  .then(async (menusData) => {
                    const menuData = convertMenu(menusData.data, languageCode);

                    const convertOperatingHours = checkMaxOperationHour(
                      menusData.data.categories
                    );
                    dispatch({
                      type: SET_OPERATING_HOURS,
                      payload: convertOperatingHours,
                    });
                    var dispatchObj = {
                      ...appParams,
                      currecyDescription: menusData.data.currencyCode,
                    };
                    dispatch({
                      type: FETCH_INITIAL_PARAMS_SUCCESSFUL,
                      payload: dispatchObj,
                    });

                    dispatch({
                      type: SELECTED_LOCATION_COORDINATES,
                      payload: locationCoordinates,
                    });

                    await Promise.all([
                      getVoucherData(
                        appParams.partnerId,
                        appParams.restaurantId,
                        isExistLocation.menuId
                      ),
                    ])
                      .then((res) => {
                        let responseData = null;
                        const pointer = res[0].data[0];
                        if (pointer !== undefined) {
                          if (res[0].data.length > 0) {
                            const siteWideInfo = {
                              ...pointer.reward,
                              promoId: pointer.id,
                            };
                            dispatch({
                              type: SET_SITEWIDE_PROMO_DETAILS,
                              payload: siteWideInfo,
                            });

                            if (res[0].data.length > 0) {
                              const modifiedData = getPromoAddedMenuCardDetails(
                                menuData,
                                pointer
                              );
                              responseData = modifiedData;
                            } else {
                              responseData = menuData;
                            }

                            dispatch({
                              type: FETCH_MENU_SUCCESS,
                              payload: responseData,
                            });
                            dispatch({
                              type: SELECTED_LOCATION_INFO,
                              payload: true,
                            });
                          } else {
                            dispatch({
                              type: FETCH_MENU_SUCCESS,
                              payload: menuData,
                            });
                            dispatch({
                              type: SELECTED_LOCATION_INFO,
                              payload: true,
                            });
                          }
                        } else {
                          dispatch({
                            type: FETCH_MENU_SUCCESS,
                            payload: menuData,
                          });
                          dispatch({
                            type: SELECTED_LOCATION_INFO,
                            payload: true,
                          });
                        }
                        history.push(ROOT + SEARCH);
                        dispatch({ type: SET_LOADER_OFF });
                      })
                      .catch((err) => {
                        dispatch({
                          type: FETCH_MENU_SUCCESS,
                          payload: menuData,
                        });
                        dispatch({
                          type: SELECTED_LOCATION_INFO,
                          payload: true,
                        });
                      });
                    history.push(ROOT + SEARCH);
                    dispatch({ type: SET_LOADER_OFF });
                  })
                  .catch((error) => {
                    dispatch({ type: SET_LOADER_OFF });
                  });
              }
            } else {
              toast.error(
                "Sorry! There is no kitchen online to serve your location.",
                { autoClose: false }
              );
              dispatch({ type: SET_LOADER_OFF });
            }
          } else {
            dispatch({
              type: FETCH_RESTAURANT_SUCCESS,
              payload: {
                ...restaurant,
                locationId: undefined,
                menuId: undefined,
              },
            });
            dispatch({
              type: FETCH_MENU_SUCCESS,
              payload: [],
            });
            toast.error(
              "Sorry! There is no kitchen online to serve your location.",
              { autoClose: false }
            );
            dispatch({ type: SET_LOADER_OFF });
          }
        }
      });
  };
};

export const fetchInitialApplicationParams = (history) => {
  return (dispatch, getState) => {
    dispatch({ type: SET_LOADER_ON });

    //application data
    const dispatchObj = {
      partnerId: "partnerId",
      restaurantName: "",
      restaurantId: "brandId",
      currecyDescription: "",
      currencyPrecision: 2,
      taxRate: 0,
      deliveryFee: "30",
      gtmKey: "12345",
      logo: "",
      bgDesktop: "",
    };

    dispatch({
      type: FETCH_INITIAL_PARAMS_SUCCESSFUL,
      payload: dispatchObj,
    });

    dispatch(fetchMenuItems());

    dispatch({ type: SET_LOADER_OFF });
  };
};

export const fetchInitialApplicationParamsWithTranslation = (
  history,
  languageCode
) => {
  return (dispatch, getState) => {
    dispatch({ type: SET_LOADER_ON });

    //application data
    const dispatchObj = {
      partnerId: "partnerId",
      restaurantName: "",
      restaurantId: "brandId",
      currecyDescription: "",
      currencyPrecision: 2,
      taxRate: 0,
      deliveryFee: "30",
      gtmKey: "12345",
      logo: "",
      bgDesktop: "",
    };

    dispatch({
      type: FETCH_INITIAL_PARAMS_SUCCESSFUL,
      payload: dispatchObj,
    });

    dispatch(fetchMenuItemsWithLanguage(languageCode));

    dispatch({ type: SET_LOADER_OFF });
  };
};

export const fetchMenuItems = () => {
  return (dispatch, getState) => {
    const { appParams } = getState().app;
    const virtualWaiterConfiguration = getState().app
      .virtualWaiterConfiguration;

    if (virtualWaiterConfiguration.menuId) {
      axios
        .get(
          appApiEndPoint + FETCH_APP_MENU + virtualWaiterConfiguration.menuId,
          {}
        )
        .then((menusData) => {
          let menuData = convertMenu(menusData.data);
          let convertOperatingHours = checkMaxOperationHour(
            menusData.data.categories
          );
          dispatch({
            type: SET_OPERATING_HOURS,
            payload: convertOperatingHours,
          });

          var dispatchObj = {
            ...appParams,
            restaurantName: menusData.data.name.translations["en-US"],
            currecyDescription: menusData.data.currencyInfo.currencyCode,
            currencyPrecision: menusData.data.currencyInfo.precision ?? 2,
          };

          dispatch({
            type: FETCH_INITIAL_PARAMS_SUCCESSFUL,
            payload: dispatchObj,
          });

          const dispatchObjRestaurant = {
            menuId: virtualWaiterConfiguration.menuId,
            locationId: "locationId",
            deliveryFee: 0,
            deliveryTimeDisplayText: "",
            location: {},
            kitchenList: [],
          };

          dispatch({
            type: FETCH_RESTAURANT_SUCCESS,
            payload: dispatchObjRestaurant,
          });

          dispatch({
            type: FETCH_MENU_SUCCESS,
            payload: menuData,
          });

          dispatch({ type: SET_LOADER_OFF });
        })
        .catch((error) => {
          dispatch({ type: SET_LOADER_OFF });
        });
    }
  };
};

export const fetchMenuItemsWithLanguage = (languageCode = "en-us") => {
  return (dispatch, getState) => {
    const { appParams } = getState().app;
    const virtualWaiterConfiguration = getState().app
      .virtualWaiterConfiguration;

    const menuRawData = getState().menu.rawData;
    const menuId = getState().menu.rawData.id;

    if (
      virtualWaiterConfiguration.menuId &&
      menuId === virtualWaiterConfiguration.menuId
    ) {
      const menuData = convertMenuWithLanguage(
        getState().menu.rawData,
        languageCode,
        dispatch
      );

      const dispatchObj = {
        ...appParams,
        restaurantName: getTranslation(menuRawData.name, languageCode),
        currecyDescription: menuRawData.currencyInfo.currencyCode,
        currencyPrecision: menuRawData.currencyInfo.precision ?? 2,
      };

      dispatch({
        type: FETCH_INITIAL_PARAMS_SUCCESSFUL,
        payload: dispatchObj,
      });

      const dispatchObjRestaurant = {
        menuId: virtualWaiterConfiguration.menuId,
        locationId: "locationId",
        deliveryFee: 0,
        deliveryTimeDisplayText: "",
        location: {},
        kitchenList: [],
      };

      dispatch({
        type: FETCH_RESTAURANT_SUCCESS,
        payload: dispatchObjRestaurant,
      });

      dispatch({
        type: FETCH_MENU_SUCCESS,
        payload: menuData,
      });
      return;
    }

    if (
      virtualWaiterConfiguration.menuId &&
      menuId !== virtualWaiterConfiguration.menuId
    ) {
      axios
        .get(
          appApiEndPoint + FETCH_APP_MENU + virtualWaiterConfiguration.menuId,
          {}
        )
        .then((menusData) => {
          const menuData = convertMenuWithLanguage(
            menusData.data,
            languageCode,
            dispatch
          );
          const convertOperatingHours = checkMaxOperationHour(
            menusData.data.categories
          );
          dispatch({
            type: SET_RAW_MENU_DATA,
            payload: menusData.data,
          });
          dispatch({
            type: SET_OPERATING_HOURS,
            payload: convertOperatingHours,
          });

          const dispatchObj = {
            ...appParams,
            restaurantName: getTranslation(menusData.data.name, languageCode),
            currecyDescription: menusData.data.currencyInfo.currencyCode,
            currencyPrecision: menusData.data.currencyInfo.precision ?? 2,
          };

          dispatch({
            type: FETCH_INITIAL_PARAMS_SUCCESSFUL,
            payload: dispatchObj,
          });

          const dispatchObjRestaurant = {
            menuId: virtualWaiterConfiguration.menuId,
            locationId: "locationId",
            deliveryFee: 0,
            deliveryTimeDisplayText: "",
            location: {},
            kitchenList: [],
          };

          dispatch({
            type: FETCH_RESTAURANT_SUCCESS,
            payload: dispatchObjRestaurant,
          });

          dispatch({
            type: FETCH_MENU_SUCCESS,
            payload: menuData,
          });

          dispatch({ type: SET_LOADER_OFF });
        })
        .catch((error) => {
          dispatch({ type: SET_LOADER_OFF });
        });
    }
  };
};

const getPromoAddedMenuCardDetails = (menuCardData, promoData) => {
  const rewardType = promoData.reward.rewardType;
  const rewardValue = promoData.reward.value;
  const promoItemList = promoData.limitations.applicability.itemIds;
  const menuCategoryData = menuCardData;
  const hashedItemList = new Hashmap();

  promoItemList.forEach((promo) => {
    hashedItemList.set(promo, promo);
  });

  menuCategoryData.forEach((cat) => {
    const catMenuData = cat.categoryData.menuList;
    return catMenuData.forEach((menu) => {
      if (hashedItemList.has(menu.internalId)) {
        menu.recipeIds.forEach((recipe, key) => {
          let rewardedPrice = null;
          if (rewardType === "FIXED") {
            rewardedPrice = recipe.sellingPrice - rewardValue;
            if (rewardedPrice < 0) {
              rewardedPrice = 0;
            }
          } else {
            rewardedPrice = (recipe.sellingPrice * (100 - rewardValue)) / 100;
            rewardedPrice = rewardedPrice.toFixed(2);
          }
          menu.recipeIds[key].originalPrice = menu.recipeIds[key].sellingPrice;
          menu.recipeIds[key].sellingPrice = parseFloat(rewardedPrice);
          menu.recipeIds[key].rewardType = rewardType;
          menu.recipeIds[key].rewardValue = rewardValue;
        });
      }
    });
  });

  menuCardData = menuCategoryData;
  return menuCardData;
};

export const setSelectedCity = (city) => {
  return (dispatch) => {
    dispatch({ type: SET_DELIVERY_LOCATION, payload: city.coordinates });
    dispatch({ type: SET_SELECTED_CITY, payload: city });
  };
};

export const setModalOn = () => {
  return (dispatch) => {
    dispatch({ type: SET_MODAL_ON, payload: null });
  };
};

export const setModalOff = () => {
  return (dispatch) => {
    dispatch({ type: SET_MODAL_OFF });
  };
};

export const setVoucheryEndPoint = (url) => {
  return (dispatch) => {
    dispatch({ type: SET_VOUCHERY_END_POINT, payload: url });
  };
};

export const setSideWidePromoDetails = (val) => {
  return (dispatch) => {
    dispatch({ type: SET_SITEWIDE_PROMO_DETAILS, payload: val });
  };
};

export const clearLocationSelectInfo = () => {
  return (dispatch) => {
    dispatch({ type: SELECTED_LOCATION_INFO, payload: false });
    dispatch({ type: SELECTED_LOCATION_COORDINATES, payload: {} });
  };
};
